import axios from "axios";
import { useEffect, useState } from "react";
import { API_BASE_URL, ROLES } from "../config/constants";
import { jwtDecode } from "jwt-decode";
import { MultiSelect } from "primereact/multiselect";

import "./CustomMultiSelect.css"; // import CSS
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "./CustomMultiSelect.css";

export default function EditUserPopup({ open, onClose, user, onSuccess }) {
  // console.log("edit userpage", user);
  const [form, setForm] = useState({
    email: "",
    password: "",
    roleName: "",
    firstName: "",
    lastName: "",
    siteIds: [],
  });
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const loggedInRole = decoded.role.role;
  const [roleOpen, setRoleOpen] = useState(false);
  const [sitesOpen, setSitesOpen] = useState(false);




  console.log("loggedInRole in edit page", loggedInRole);

  const [sites, setSites] = useState([
  ]);

  const getSites = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/site`);
      setSites(res.data);
    } catch (e) {
      console.error("Site API error:", e);
    }
  };

  useEffect(() => {
    getSites();
  }, []);

  useEffect(() => {
    if (user) {
      setForm({
        email: user.email,
        password: "",
        firstName: user.firstName,
        lastName: user.lastName,
        roleName: user.role?.role || "",
        siteIds: user.sites?.map((s) => s.id) || [],
        isActive: user.isActive,
      });
    }
  }, [user]);

  if (!open) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

    // ...existing code...

  const handleUpdate = async () => {
    const payload = {
      email: form.email,
      password: form.password || undefined,
      roleName: form.roleName,
      siteIds: form.siteIds,
      firstName: form.firstName,
      lastName: form.lastName,
      isActive: form.isActive,
    };

    try {
      await axios.put(`${API_BASE_URL}/update-user/${user.id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Close Edit popup
      onClose();

      // Trigger success popup in parent
      onSuccess();
    } catch (err) {
      console.log("error", err?.response?.data.message);
      alert(err?.response?.data.message);
    }
  };


  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4 backdrop-blur-md">
      <div className="w-full max-w-[71.5625rem] h-auto xl:h-[42.4375rem] bg-[#051E1C] rounded-[0.625rem] overflow-hidden">

        {/* Header */}
        <div className="relative mb-[1.75rem] flex items-center justify-center">
          <h2 className="text-white font-poppins text-[1.75rem] font-medium leading-[1.25rem] mt-[4.5rem]">
            Edit User
          </h2>

          <button
            onClick={onClose}
            className="absolute top-[2.625rem] right-[3.0625rem] text-white/70 hover:text-white w-[1.16675rem] h-[1.16675rem]"
          >
            ✕
          </button>
        </div>


        {/* Form Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-[3.125rem] mx-[6.125rem]">

          {/* First Name */}
          <div>
            <label className="block mb-[0.8125rem] font-poppins text-[1.1667rem] font-normal leading-[1.6667rem] text-[#676F6E]">
              First Name
            </label>
            <input
              name="firstName"
              placeholder="Enter your first name"
              value={form.firstName}
              onChange={handleChange}
              className="rounded-md bg-white/10 font-poppins w-[28.125rem] h-[3.4375rem] px-[1rem] py-[0.1667rem] text-white text-[1rem] outline-none"
            />
          </div>

          {/* Last Name */}
          <div>
            <label className="block mb-[0.8125rem] font-poppins text-[1.1667rem] font-normal leading-[1.6667rem] text-[#676F6E]">
              Last Name
            </label>
            <input
              name="lastName"
              value={form.lastName}
              placeholder="Enter your last name"
              onChange={handleChange}
              className="rounded-md bg-white/10 font-poppins w-[28.125rem] h-[3.4375rem] px-[1rem] py-[0.1667rem] text-white text-[1rem] outline-none"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block mb-[0.8125rem] font-poppins text-[1.1667rem] font-normal leading-[1.6667rem] text-[#676F6E]">
              Email ID
            </label>
            <input
              name="email"
              placeholder="Enter your email"
              value={form.email}
              onChange={handleChange}
              className="rounded-md bg-white/10 font-poppins w-[28.125rem] h-[3.4375rem] px-[1rem] py-[0.1667rem] text-white text-[1rem] outline-none"
            />
          </div>

          {/* Password */}
          {loggedInRole !== ROLES.USER && (
            <div>
              <label className="block mb-[0.8125rem] font-poppins text-[1.1667rem] font-normal leading-[1.6667rem] text-[#676F6E]">
                New Password
              </label>
              <input
                name="password"
                type="password"
                placeholder="Leave empty to keep same password"
                value={form.password}
                onChange={handleChange}
                className="rounded-md bg-white/10 font-poppins w-[28.125rem] h-[3.4375rem] px-[1rem] py-[0.1667rem] text-white text-[1rem] outline-none"
              />
            </div>
          )}

          {/* Role */}
          {loggedInRole !== ROLES.USER && (
            <div className="flex flex-col w-full max-w-[28.125rem]">
              <label className="block text-[1.125rem] font-poppins font-medium mb-[0.8125rem] text-[#676F6E]">
                Select Site
              </label>

              <MultiSelect
                value={form.siteIds}
                options={sites.map((site) => ({ label: site.siteName, value: site.id }))}
                onChange={(e) => {
                  setForm((prev) => ({ ...prev, siteIds: e.value }));
                }}
                maxSelectedLabels={3}
                placeholder="Select Sites"
                className="w-full font-poppins border-none max-w-[28.125rem] h-[3.4375rem] custom-multiselect no-focus-ring"
                style={{
                  backgroundColor: sitesOpen ? "#0A3D38" : "#33504D75",
                  borderRadius: "6px",
                  fontSize: "1rem",
                }}
                panelStyle={{
                  fontSize: "14px",
                  backgroundColor: "#0A3D38",
                }}
                showSelectAll={false}
                showClear={false}
                panelHeaderTemplate={null}
                onShow={() => setSitesOpen(true)}
                onHide={() => setSitesOpen(false)}
                dropdownIcon={
                  <img
                    src={sitesOpen ? "/assets/dropdown-icon.svg" : "/assets/dropdown-open.svg"}
                    alt="dropdown"
                    className="w-[1rem] h-[1rem]"
                  />
                }
              />
            </div>

          )}



          {/* Sites */}
          {loggedInRole !== ROLES.USER && (
            <div className="flex flex-col w-full max-w-[28.125rem]">
              <label className="block text-[1.125rem] font-poppins font-medium mb-[0.8125rem] text-[#676F6E]">
                Select Role
              </label>

              <div className="relative">
                <button
                  type="button"
                  onClick={() => setRoleOpen(!roleOpen)}
                  className={`w-full font-poppins max-w-[28.125rem] h-[3.4375rem] py-[0.1667rem] px-[1rem] flex items-center justify-between rounded-md text-[1rem] transition-colors
        ${roleOpen ? "bg-[#0A3D38]" : "bg-[#33504D75]"}
        ${form.roleName ? "text-white" : "text-white/60"}
      `}
                >
                  <span>{form.roleName || "Select Role"}</span>
                  <img
                    src={roleOpen ? "/assets/dropdown-icon.svg" : "/assets/dropdown-open.svg"}
                    alt="dropdown"
                    className="w-4 h-4 transition-transform"
                  />
                </button>

                {roleOpen && (
                  <div
                    className="absolute top-full w-full max-w-[28.125rem] bg-[#0A3D38] rounded-[6px] shadow-lg z-50 max-h-56 overflow-y-auto"
                    style={{ fontSize: "1rem" }}
                  >
                    {[
                      ...(loggedInRole !== ROLES.ADMIN ? ["Super-Admin"] : []),
                      "Admin",
                      "User",
                    ].map((role, index) => (
                      <div
                        key={role}
                        onClick={() => {
                          setForm((prev) => ({ ...prev, roleName: role }));
                          setRoleOpen(false);
                        }}
                        className={`flex items-center gap-[0.667rem] px-[1rem] py-[0.333rem] h-[3.417rem] cursor-pointer hover:bg-[#072E2A] text-white text-[1rem] ${index !== 0 ? "border-t border-[#FFFFFF24]" : ""
                          }`}
                      >
                        <div
                          className={`w-4 h-4 rounded-full border flex items-center justify-center ${form.roleName === role ? "border-[#F3E5DE]" : "border-[#F3E5DE]/50"
                            }`}
                        >
                          {form.roleName === role && (
                            <div className="w-2 h-2 bg-[#F3E5DE] rounded-full" />
                          )}
                        </div>
                        <span className="text-[#CACCCC] text-[1rem] font-medium font-poppins">
                          {role}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

          )}

        </div>

        {/* Actions */}
        <div className="mt-10 flex justify-center gap-6 mb-12">
          <button
            onClick={handleUpdate}
            className="rounded-[10px] bg-[#147A6F] w-[28.125rem] font-poppins h-[3.75rem] px-[1.6667rem] py-[0.8333rem] text-white text-[1.3333rem] font-normal leading-[2rem]"
          >
            Update User
          </button>
        </div>
      </div>


    </div>

  );
}

